import React from  "react"
import NewsSection from "./NewsSection";
import RightPanel from "./RightPanels";
import VideoSection from "./VideoSection";
import { useGlobal } from "./Reducer";
export default    (props)=>
    {

        const [globalState, globalActions] = useGlobal();

        const month=globalState.appData.month;
        const year=globalState.appData.year;

        return (<div className="container theBaseContainer">

{false && month==5 && year==2023 && <div className="row  " style={{marginTop:40,marginLeft:0}}>
          <div style={{paddingRight:0,paddingLeft:0}} className="col-lg-12 col-md-12 whitebg  ogn_line_before ">
                    <div style={{paddingLeft:12,paddingRight:15,padding:10,fontSize:20,textAlign:'center',fontFamily:'MeNfontBold',border:'1px solid #a0afb2',borderTopWidth:0}}  >
                    It’s Trivia Time! Play the trivia game for a chance to win a Here4TN tumbler.{" "} 
                    <a style={{textDecoration:"underline"}} href="http://here4tntriviagame.com/" target="_blank">
                     Play now through May 31.
                     </a>
                    </div>
               </div>
                </div>  }
              
 
        <div className="row">


     
        
        <div className="col-lg-9 col-md-12">
       
<NewsSection/>        
        <VideoSection/>
        
        </div>
        <div className="col-lg-3 col-md-12 nopadding">
        
          <RightPanel/>
        
        
        
        
        
        </div>
        
        </div>
        </div>);
    }